export const palette = {
  green: {
    color: "#61b510",
    hover: "#80c33f",
  },
  black: {
    color: "#000",
    hover: "#333",
  },
  orange: {
    color: "#f7760d",
    hover: "#FF9800",
  },
  white: {
    color: "#fff",
    hover: "",
  },
}
